<template>
  <div>
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('add') }} Custom Fields</div>
      <router-link class="btn-blue" to="/master/custom-fields">Modules List</router-link>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 mb-4 align-self-center">
          <div>
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input @focus="onFocusHandler" v-model="module_name" placeholder="." disabled />
                <label>Module Name</label>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-12 mb-4"
          v-for="(customField, customFieldIndex) in customFieldList"
          :key="customFieldIndex"
        >
          <div class="row border mx-0 rounded-10 py-3">
            <div class="col-11">
              <div class="row">
                <div class="col-lg-4 mb-4">
                  <div class="input-material">
                    <input type="text" step="any" v-model="customField.fieldvalue" placeholder="." />
                    <label>Field Name</label>
                  </div>
                </div>

                <div class="col-lg-4 mb-4">
                  <multiselect
                    v-model="customField.type"
                    :options="['text', 'textarea', 'number','checkbox']"
                    placeholder="Select Type"
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                </div>

                <div class="col-lg-4 mb-4">
                  <multiselect
                    v-model="customField.priority"
                    :options="['Compulsary', 'Optional']"
                    placeholder="Select Type"
                    :allowEmpty="false"
                    :showLabels="false"
                  ></multiselect>
                </div>

                <div class="col-lg-4 mb-4">
                  <div class="input-material">
                    <input type="number" step="any" v-model="customField.order_id" placeholder="." />
                    <label>Order</label>
                  </div>
                </div>

                <div
                  class="col-lg-4 mb-4"
                  v-if="customField.type =='text' || customField.type =='textarea' || customField.type =='number'"
                >
                  <div class="input-material">
                    <input
                      type="number"
                      placeholder="Minimum Length"
                      v-model="customField.min_length"
                    />
                    <label>Minimum Length</label>
                  </div>
                </div>

                <div
                  class="col-lg-4 mb-4"
                  v-if="customField.type =='text' || customField.type =='textarea' || customField.type =='number'"
                >
                  <div class="input-material">
                    <input
                      type="number"
                      v-model="customField.max_length"
                      placeholder="Maximum Length"
                    />
                    <label>Maximum Length</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-1 px-0 d-flex justify-content-center align-items-center border-left">
              <button
                v-if="customFieldIndex === 0"
                @click.prevent.stop="increaseformField()"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
              </button>
              <button
                v-else
                @click.prevent.stop="decreaseformField(customFieldIndex)"
                class="btn-transparent"
              >
                <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="onFinalSubmit(true)"
          >{{ $t('save') }}</button>
          <!-- <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            type="submit"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>-->
          <!-- <button @click.prevent.stop="resetHandler" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="/master/custom-fields"
          >{{ $t('cancel') }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      list: [],
      removedFields: [],
      table_name: null,
      custom_field_is_active: true,
      btenable: false,
      // v-validate="'required|email'"
      submitted: false,
      module_name: "",
      customFieldList: [
        // {
        //   fieldvalue: "",
        //   type: "",
        //   min_length: null,
        //   max_length: null,
        //   priority: "Compulsary",
        //   order_id: null,
        // //   field_is_active: true,
        // }
      ],
    };
  },
  mounted() {
    const { module } = this.$route.params;
    if (module) {
      if (module == 1) {
        this.module_name = "Movies";
        this.table_name = "ms_movies";
      } else if (module == 2) {
        this.module_name = "Cinemas";
        this.table_name = "ms_cinemas";
      } else {
        this.$router.go(-1);
      }
    } else {
      this.$router.go(-1);
    }
    this.getCustomFields();
    // console.log("Gender :", Gender);
    // this.resetHandler();
  },
  methods: {
    getCustomFields: function () {
      let payload = {
        table_name: this.table_name,
      };
      MasterService.getCustomFields(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.list = _.sortBy(data.Records, ["order_id"]);
            this.list.map((field, index) => {
              //   if (field.custom_field_type == "checkbox") {
              //     this.input_data[index] =
              //       this.input_data[index] == undefined
              //         ? false
              //         : this.input_data[index];
              //   }
              this.customFieldList.push({
                custom_field_id: field.custom_field_id,
                fieldvalue: field.custom_field_name,
                type: field.custom_field_type,
                min_length: field.min_length,
                max_length: field.max_length,
                priority:
                  field.field_is_required == "Y" ? "Compulsary" : "Optional",
                order_id: field.order_id,
                //   field_is_active: field.field_is_active
              });
            });
          } else {
            // Show Errors
            // this.$toasted.show(data.message);
            if (this.customFieldList.length == 0) {
              this.customFieldList.push({
                fieldvalue: "",
                type: "",
                min_length: null,
                max_length: null,
                priority: "Compulsary",
                order_id: null,
                //   field_is_active: true,
              });
            }
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    increaseformField: function () {
      this.customFieldList.push({
        fieldvalue: "",
        type: "",
        min_length: null,
        max_length: null,
        priority: "Compulsary",
        order_id: null,
        // field_is_active: true,
      });
    },
    decreaseformField: function (index) {
      if (this.customFieldList[index].custom_field_id) {
        this.removedFields.push(this.customFieldList[index]);
      }
      console.log("this.removedFields :>> ", this.removedFields);
      this.customFieldList.splice(index, 1);
    },
    // resetHandler: function() {
    //   this.Gender.map(x => {
    //     if (x.type === "text" || x.type === "date") {
    //       x.fieldvalue = "";
    //     } else if (x.type === "radio") {
    //       x.fieldvalue = true;
    //     }
    //   });
    // },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      let finalFlag = true;
      this.customFieldList.map((x) => {
        if (x.fieldvalue == "") {
          finalFlag = false;
        } else if (x.order_id == null || String(x.order_id).length == 0) {
          finalFlag = false;
        } else if (
          x.type !== "checkbox" &&
          (x.min_length == null || String(x.min_length).length == 0)
        ) {
          finalFlag = false;
        } else if (
          x.type !== "checkbox" &&
          (x.max_length == null || String(x.max_length).length == 0)
        ) {
          finalFlag = false;
        }
      });
      if (finalFlag) {
        //   this.btenable = true;
        let payload = {
          table_name: this.table_name,
          customFieldList: this.customFieldList,
          custom_field_is_active: this.custom_field_is_active,
          removedFields: this.removedFields,
        };
        console.log("payload :", payload);

        MasterService.AddCustomFields(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              // this.onResetForm();
              if (redirect) {
                this.$router.push({
                  path: "/master/custom-fields",
                });
              }
              this.submitted = false;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      } else {
        this.$toasted.show("Please fill all details");
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CustomFieldsComponents/addCustomFields.vue